<div class="flex min-h-[calc(100vh-48px)] flex-col gap-5 bg-light-color px-6 py-6 font-base text-dark-color">
  <header class="flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-6 text-light-color shadow-[0_14px_40px_var(--box-shadow-color)] md:flex-row md:items-start md:justify-between md:gap-6">
    <div class="flex flex-col gap-2">
      <p class="text-xs uppercase tracking-[0.12em] text-light-color/80">Mensagens</p>
      <h1 class="text-2xl font-semibold leading-tight">Carteira de mensagens</h1>
      <p class="max-w-3xl text-sm text-light-color/90">
        Cadastre, edite e gerencie as mensagens prontas para usar nas campanhas.
      </p>
    </div>
    <div class="grid grid-cols-2 gap-3 text-sm md:grid-cols-2">
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Mensagens liberadas</p>
        <strong class="text-lg">{{ mensagensLiberadas || 0 }}</strong>
      </div>
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Mensagens cadastradas</p>
        <strong class="text-lg">{{ mensagensCadastradas || 0 }}</strong>
      </div>
    </div>
  </header>

  <section class="flex flex-col gap-3 rounded-xl border border-border-color bg-white px-5 py-5 shadow-[0_12px_36px_var(--box-shadow-color)]">
    <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div class="flex items-center gap-2 text-sm text-dark-color">
        <mat-icon>chat</mat-icon>
        <span>Mensagens prontas para disparos.</span>
      </div>
      <button
        type="button"
        (click)="openModalNewMessage()"
        class="inline-flex items-center gap-2 rounded-base bg-primary-color px-4 py-3 text-sm font-semibold text-white shadow-md transition hover:bg-primary-hover">
        <mat-icon>add</mat-icon>
        Nova mensagem
      </button>
    </div>

    <div class="overflow-hidden rounded-xl border border-border-color">
      <table class="min-w-full divide-y divide-border-color text-sm">
        <thead class="bg-light-color/60">
          <tr>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Título</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Mensagem</th>
            <th class="px-4 py-3 w-32 text-right font-semibold text-dark-color">Ações</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-border-color">
          <tr
            *ngFor="let message of listMessages; let i = index; trackBy: trackById"
            class="hover:bg-light-color/60 transition">
            <td class="px-4 py-3 text-dark-color">{{ message.title }}</td>
            <td class="px-4 py-3 text-dark-color">
              <span class="block max-w-full truncate break-all">{{ message.message }}</span>
            </td>
            <td class="px-4 py-3">
              <div class="flex justify-end gap-2">
                <button
                  type="button"
                  (click)="openModalEditMessage(message)"
                  class="flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                  title="Editar">
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  type="button"
                  (click)="openModalDeleteMessage(i)"
                  class="flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-hover hover:text-primary-hover"
                  title="Excluir">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!listMessages?.length">
            <td colspan="3" class="px-4 py-6 text-center text-dark-color/70">
              Nenhuma mensagem cadastrada.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>

<!-- MODAL: Nova Mensagem -->
<ng-container *ngIf="modalNewMessage">
  <div class="fixed inset-0 z-50 flex items-center justify-center px-4">
    <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" (click)="closeModalNewMessage()"></div>

    <div
      role="dialog" aria-modal="true"
      class="relative w-full max-w-2xl rounded-2xl border border-border-color bg-white shadow-xl flex max-h-[90vh] flex-col">
      <div class="flex items-center justify-between border-b border-border-color px-5 py-4">
        <h2 class="text-base font-semibold text-dark-color">Adicionar Nova Mensagem</h2>
        <button class="inline-flex items-center justify-center rounded-xl p-2 hover:bg-light-color/60"
                (click)="closeModalNewMessage()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="flex-1 overflow-y-auto px-5 py-4">
        <form [formGroup]="formMessage" class="space-y-4" (ngSubmit)="cadastrarMensagem()">
          <label class="block text-sm text-dark-color">
            Título da Mensagem
            <input
              type="text" formControlName="title" id="title" name="title"
              class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
          </label>

          <label class="block text-sm text-dark-color">
            Referência
            <select
              (change)="addRefMessage($event)"
              class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color">
              <option *ngFor="let letra of 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')" [value]="letra" [selected]="letra === 'A'">{{ letra }}</option>
            </select>
          </label>

          <label class="block text-sm text-dark-color">
            Mensagem
            <div class="relative">
              <textarea
                formControlName="text"
                [(ngModel)]="text"
                rows="5"
                placeholder="Mensagem"
                class="mt-1 block w-full max-w-full box-border resize-y rounded-base border border-border-color px-3 py-2 text-sm shadow-sm pr-12 outline-none focus:border-primary-color"></textarea>
              <button
                type="button"
                (click)="toggleEmojiPicker($event)"
                class="absolute bottom-2 right-2 inline-flex items-center justify-center rounded-lg px-2 py-1 text-lg hover:bg-light-color/80"
                aria-label="Inserir emoji">😊</button>
            </div>
          </label>

          <div *ngIf="isEmojiPickerVisible" class="rounded-base border border-border-color p-2">
            <emoji-mart (emojiClick)="addEmoji($event)"></emoji-mart>
          </div>

          <div class="pt-2">
            <button
              type="submit"
              class="inline-flex w-full items-center justify-center gap-2 rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white shadow transition hover:bg-primary-hover">
              Enviar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>

<!-- MODAL: Editar Mensagem -->
<ng-container *ngIf="modalEditMessage">
  <div class="fixed inset-0 z-50 flex items-center justify-center px-4">
    <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" (click)="closeModalEditMessage()"></div>

    <div
      role="dialog" aria-modal="true"
      class="relative w-full max-w-2xl rounded-2xl border border-border-color bg-white shadow-xl flex max-h-[90vh] flex-col">
      <div class="flex items-center justify-between border-b border-border-color px-5 py-4">
        <h2 class="text-base font-semibold text-dark-color">Editar Mensagem</h2>
        <button class="inline-flex items-center justify-center rounded-xl p-2 hover:bg-light-color/60"
                (click)="closeModalEditMessage()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="flex-1 overflow-y-auto px-5 py-4">
        <form [formGroup]="formEditMessage" class="space-y-4" (ngSubmit)="editarMensagem()">
          <label class="block text-sm text-dark-color">
            Título da Mensagem
            <input
              type="text" id="title" name="title" formControlName="title"
              class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
          </label>

          <label class="block text-sm text-dark-color">
            Referência
            <select
              (change)="addRefMessageEdit($event)"
              class="mt-1 block w-full max-w-full box-border rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color">
              <option *ngFor="let letra of 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')" [value]="letra" [selected]="letra === 'A'">{{ letra }}</option>
            </select>
          </label>

          <label class="block text-sm text-dark-color">
            Mensagem
            <div class="relative">
              <textarea
                formControlName="message"
                rows="5"
                placeholder="Mensagem"
                class="mt-1 block w-full max-w-full box-border resize-y rounded-base border border-border-color px-3 py-2 text-sm shadow-sm pr-12 outline-none focus:border-primary-color"></textarea>
              <button
                type="button"
                (click)="toggleEmojiPicker($event)"
                class="absolute bottom-2 right-2 inline-flex items-center justify-center rounded-lg px-2 py-1 text-lg hover:bg-light-color/80"
                aria-label="Inserir emoji">😊</button>
            </div>
          </label>

          <div *ngIf="isEmojiPickerVisible" class="rounded-base border border-border-color p-2">
            <emoji-mart (emojiClick)="addEmojiEditForm($event)"></emoji-mart>
          </div>

          <div class="pt-2">
            <button
              type="submit"
              class="inline-flex w-full items-center justify-center gap-2 rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white shadow transition hover:bg-primary-hover">
              Enviar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>

<!-- MODAL: Confirmar Exclusão -->
<ng-container *ngIf="modalDeleteMessage">
  <div class="fixed inset-0 z-50 flex items-center justify-center px-4">
    <div class="fixed inset-0 bg-black/60 backdrop-blur-sm" (click)="closeModalDeleteMessage()"></div>

    <div
      role="dialog" aria-modal="true"
      class="relative w-full max-w-md rounded-2xl border border-border-color bg-white p-5 shadow-xl">
      <div class="flex items-center justify-between">
        <span class="text-base font-semibold text-dark-color">Confirmar Exclusão</span>
        <button class="inline-flex items-center justify-center rounded-xl p-2 hover:bg-light-color/60"
                (click)="closeModalDeleteMessage()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="mt-3 text-sm text-dark-color">
        Tem certeza de que deseja excluir essa mensagem?
      </div>

      <div class="mt-5 flex items-center justify-end gap-3">
        <button
          type="button"
          (click)="closeModalDeleteMessage()"
          class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color">
          Cancelar
        </button>
        <button
          type="button"
          (click)="deleteMessage()"
          class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</ng-container>

<app-alert></app-alert>
<app-loading-modal></app-loading-modal>
